import { useEffect } from "react";
import { CONTACT } from "@/lib/constants";

const SITE_NAME = "Forage Animal Health & Nutrition";
const DEFAULT_DESC =
  "Forage Animal Health & Nutrition Pvt. Ltd. — pharmaceutical-grade veterinary supplements, mineral and feed formulations, manufactured in India for global animal health.";

export default function SEO({ title, description, path = "", rawTitle = false }) {
  const fullTitle = rawTitle
    ? title
    : title
      ? `${title} | ${SITE_NAME}`
      : SITE_NAME;
  const desc = description || DEFAULT_DESC;

  useEffect(() => {
    document.title = fullTitle;
    setMeta("description", desc);
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", desc, "property");
    setMeta("og:type", "website", "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);

    // Canonical
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = `${window.location.origin}${path || window.location.pathname}`;

    // JSON-LD organization (only on homepage)
    if (path === "/" || path === "") {
      let ld = document.getElementById("ld-org");
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "ld-org";
        document.head.appendChild(ld);
      }
      ld.text = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: SITE_NAME,
        legalName: CONTACT.company,
        url: window.location.origin,
        logo: `${window.location.origin}/forage-logo.jpg`,
        description: desc,
        telephone: CONTACT.phoneTel,
        email: CONTACT.email,
        address: {
          "@type": "PostalAddress",
          streetAddress: CONTACT.address.line1,
          addressLocality: CONTACT.address.line2,
          addressRegion: CONTACT.address.state,
          postalCode: CONTACT.address.pincode,
          addressCountry: "IN",
        },
        contactPoint: [
          {
            "@type": "ContactPoint",
            telephone: CONTACT.phoneTel,
            contactType: "sales",
            email: CONTACT.email,
            areaServed: "IN",
            availableLanguage: ["English", "Hindi"],
          },
        ],
      });
    }
  }, [fullTitle, desc, path]);

  return null;
}

function setMeta(name, content, attr = "name") {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
